/**
 * IMPORTS
 */

import { remessaEmAndamentoRepository } from "@/repositories/remessa-em-andamento";

/**
 * Função que busca remessas em andamento de um cliente 🛠️.
 */
const handlerGetRemessaEmAndamento = async (
  accessToken: string,
  cliente_id: number,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await remessaEmAndamentoRepository.getAllRemessaEmAndamento(
      accessToken,
      cliente_id,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM BUSCAR REMESSAS EM ANDAMENTO: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export { handlerGetRemessaEmAndamento };
